import { render } from "./GroupSelectionResponseOptions.vue?vue&type=template&id=38792e40&scoped=true&ts=true"
import script from "./GroupSelectionResponseOptions.vue?vue&type=script&lang=ts"
export * from "./GroupSelectionResponseOptions.vue?vue&type=script&lang=ts"

import "./GroupSelectionResponseOptions.vue?vue&type=style&index=0&id=38792e40&lang=css"
import "./GroupSelectionResponseOptions.vue?vue&type=style&index=1&id=38792e40&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38792e40"]])

export default __exports__